import jwt_decode from "jwt-decode";

export function setSizeUsersToAprove(state, size) {
    state.sizeUsersToAprove = size;
}

export function setUser(state, user) {
    if(user)
        state.user = jwt_decode(user);
}

export function setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
    if(!state.selectedCompany &&  localStorage.getItem('selectedCompany')){
        state.selectedCompany = localStorage.getItem('selectedCompany');
        state.selectedCompanyObj = JSON.parse(localStorage.getItem('selectedCompanyObj'));
    }else if(!state.selectedCompany && userInfo.pessoa){
        state.selectedCompany = (userInfo.pessoa.empresas.length > 0) ? userInfo.pessoa.empresas[0].id : null;
        state.selectedCompanyObj = (userInfo.pessoa.empresas.length > 0) ? userInfo.pessoa.empresas[0] : null;
    }
}

export function removerUserInfo(state) {
    state.userInfo = null;
}

export function setSelectedCompany(state, company) {
    if(!company){
        state.selectedCompany = company;
        state.selectedCompanyObj = company;
    }else{
        localStorage.setItem('selectedCompany', company.value);
        localStorage.setItem('selectedCompanyObj', JSON.stringify(company.data));
        state.selectedCompany = company.value;
        state.selectedCompanyObj = company.data;
    }
}

export function adicionarPermissao(state, permissao) {
    state.permissao = permissao;
}

export function setAlertas(state, alertas) {
    state.alertas = alertas;
}

export function setListaEmpresas(state, payload) {
    state.listaEmpresas = payload.map((el) => {
        return {
          value: el.id,
          text: el.nomeFantasia || el.razaoSocial,
          logo: el.logoDaEmpresa,
          data: el,
        };
    });
}